import { createTheme, ThemeProvider, useTheme } from '@mui/material';
import ButtonBase from './ButtonBase';
import { ButtonBaseProps } from './button.types';
import { applyButtonStyles } from './button.utility';
import { useMemo } from 'react';
import { buttonStyleDefaultData } from './button.data';

type SecondaryButtonProps = ButtonBaseProps;

function ButtonSecondary({ children, ...rest }: SecondaryButtonProps) {
  const theme = useTheme();
  const primaryColor = theme.palette.primary?.main;
  const palette =
    theme.buttonStyle?.secondary ||
    buttonStyleDefaultData({
      defaultColor: primaryColor,
      hoverColor: theme.palette.themeColor?.main,
      secondaryHoverColor: theme.palette.secondary?.dark,
    }).secondary;
  const themeOb = useMemo(
    () =>
      createTheme({
        palette: {
          ...theme.palette,
          primary: {
            main: primaryColor,
            dark: primaryColor,
          },
        },
        components: {
          MuiButtonBase: {
            defaultProps: {
              disableRipple: true,
            },
            styleOverrides: {
              root: {
                height: palette.height,
              },
            },
          },
          MuiButton: {
            styleOverrides: {
              outlined: {
                ...applyButtonStyles(palette),
                textTransform: 'none',
                fontFamily: theme.palette.primaryFontSemiBoldType,
              },
            },
          },
        },
      }),
    []
  );

  return (
    <ThemeProvider theme={themeOb}>
      <ButtonBase variant="secondary" {...rest}>
        {children}
      </ButtonBase>
    </ThemeProvider>
  );
}

export default ButtonSecondary;
